// extracted by mini-css-extract-plugin
module.exports = {"hoursInput":"TaskActualHoursLog_hoursInput__1vfyo"};